import { useStore } from '@stores';
import { useEffect } from 'react';

export const useTenantVat = () => {
  const { sessionStore, serviceStore } = useStore();

  const tenantVat = sessionStore.currentLogin?.tenant?.vat;
  const isTenantVat = sessionStore.currentLogin?.tenant?.isVat;
  const vat = isTenantVat ? tenantVat : 0;

  useEffect(() => {
    serviceStore.setTenantVat(vat);
  }, [vat, serviceStore]);

  return vat;
};
